import { render, staticRenderFns } from "./BarTwo.vue?vue&type=template&id=541289f0&scoped=true&"
import script from "./BarTwo.vue?vue&type=script&lang=js&"
export * from "./BarTwo.vue?vue&type=script&lang=js&"
import style0 from "./BarTwo.vue?vue&type=style&index=0&id=541289f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541289f0",
  null
  
)

export default component.exports